import { differenceInMonths } from "date-fns";
import moment from "moment";

const shippingAllTimeValues = [
  {
    behaviourKey: "EFFICIENT_AUXILIARY_ENGINE_USE",
    behaviourName: "Efficient Auxiliary Engine Use",
    behaviourAcronym: "EAEU",
    behaviourPosition: 2,
    countEventsPerformablePreSignol: 49,
    countEventsPerformablePostSignol: 62,
    countEventsPerformedPreSignol: 22,
    countEventsPerformedPostSignol: 36,
    avgSuccessRatePreSignolWeighted: {
      value: 44.9,
      standardError68: 7.1,
      standardError95: 13.9,
    },
    avgSuccessRatePostSignolWeighted: {
      value: 58.1,
      standardError68: 6.3,
      standardError95: 12.3,
    },
    avgSuccessRateChange: {
      value: 13.2,
      standardError68: 9.5,
      standardError95: 18.5,
    },
  },
  {
    behaviourKey: "PROMPT_DEPARTURE",
    behaviourName: "Prompt Departure",
    behaviourAcronym: "PD",
    behaviourPosition: 4,
    countEventsPerformablePreSignol: 398,
    countEventsPerformablePostSignol: 168,
    countEventsPerformedPreSignol: 156,
    countEventsPerformedPostSignol: 53,
    avgSuccessRatePreSignolWeighted: {
      value: 39.2,
      standardError68: 2.4,
      standardError95: 4.8,
    },
    avgSuccessRatePostSignolWeighted: {
      value: 31.5,
      standardError68: 3.6,
      standardError95: 7,
    },
    avgSuccessRateChange: {
      value: 7.6,
      standardError68: 4.4,
      standardError95: 8.6,
    },
  },
  {
    behaviourKey: "EFFICIENT_SFOC",
    behaviourName: "Efficient SFOC",
    behaviourAcronym: "ESFOC",
    behaviourPosition: 1,
    countEventsPerformablePreSignol: 164,
    countEventsPerformablePostSignol: 213,
    countEventsPerformedPreSignol: 46,
    countEventsPerformedPostSignol: 68,
    avgSuccessRatePreSignolWeighted: {
      value: 28,
      standardError68: 3.5,
      standardError95: 6.9,
    },
    avgSuccessRatePostSignolWeighted: {
      value: 31.9,
      standardError68: 3.2,
      standardError95: 6.3,
    },
    avgSuccessRateChange: {
      value: 3.9,
      standardError68: 4.7,
      standardError95: 9.2,
    },
  },
  {
    behaviourKey: "OPTIMAL_TRIM",
    behaviourName: "Optimal Trim",
    behaviourAcronym: "OT",
    behaviourPosition: 3,
    countEventsPerformablePreSignol: 92,
    countEventsPerformablePostSignol: 154,
    countEventsPerformedPreSignol: 38,
    countEventsPerformedPostSignol: 55,
    avgSuccessRatePreSignolWeighted: {
      value: 35.3,
      standardError68: 5.1,
      standardError95: 10.1,
    },
    avgSuccessRatePostSignolWeighted: {
      value: 41.7,
      standardError68: 3.9,
      standardError95: 7.6,
    },
    avgSuccessRateChange: {
      value: 5.6,
      standardError68: 6.4,
      standardError95: 12.6,
    },
  },
  {
    behaviourKey: "OPTIMAL_BOILER_LOAD",
    behaviourName: "Optimal Boiler Load",
    behaviourAcronym: "OBL",
    behaviourPosition: 5,
    countEventsPerformablePreSignol: 92,
    countEventsPerformablePostSignol: 154,
    countEventsPerformedPreSignol: 38,
    countEventsPerformedPostSignol: 55,
    avgSuccessRatePreSignolWeighted: {
      value: 41.3,
      standardError68: 5.1,
      standardError95: 10.1,
    },
    avgSuccessRatePostSignolWeighted: {
      value: 40.7,
      standardError68: 3.9,
      standardError95: 7.6,
    },
    avgSuccessRateChange: {
      value: -0.4,
      standardError68: 2.3,
      standardError95: 4.9,
    },
  },
];

const shippingMonthyValues = {
  [moment.utc().subtract(1, "month").format("YYYY/MM/DD")]: [
    {
      behaviourKey: "EFFICIENT_AUXILIARY_ENGINE_USE",
      behaviourName: "Efficient Auxiliary Engine Use",
      behaviourAcronym: "EAEU",
      behaviourPosition: 2,
      countEventsPerformablePreSignol: 49,
      countEventsPerformablePostSignol: 37,
      countEventsPerformedPreSignol: 22,
      countEventsPerformedPostSignol: 23,
      avgSuccessRatePreSignolWeighted: {
        value: 44.9,
        standardError68: 7.1,
        standardError95: 13.9,
      },
      avgSuccessRatePostSignolWeighted: {
        value: 62.2,
        standardError68: 8,
        standardError95: 15.6,
      },
      avgSuccessRateChange: {
        value: 17.3,
        standardError68: 10.7,
        standardError95: 20.9,
      },
    },
    {
      behaviourKey: "PROMPT_DEPARTURE",
      behaviourName: "Prompt Departure",
      behaviourAcronym: "PD",
      behaviourPosition: 4,
      countEventsPerformablePreSignol: 398,
      countEventsPerformablePostSignol: 70,
      countEventsPerformedPreSignol: 156,
      countEventsPerformedPostSignol: 17,
      avgSuccessRatePreSignolWeighted: {
        value: 39.2,
        standardError68: 2.4,
        standardError95: 4.8,
      },
      avgSuccessRatePostSignolWeighted: {
        value: 24.3,
        standardError68: 5.1,
        standardError95: 10,
      },
      avgSuccessRateChange: {
        value: 14.9,
        standardError68: 5.7,
        standardError95: 11.1,
      },
    },
    {
      behaviourKey: "EFFICIENT_SFOC",
      behaviourName: "Efficient SFOC",
      behaviourAcronym: "ESFOC",
      behaviourPosition: 1,
      countEventsPerformablePreSignol: 164,
      countEventsPerformablePostSignol: 95,
      countEventsPerformedPreSignol: 46,
      countEventsPerformedPostSignol: 30,
      avgSuccessRatePreSignolWeighted: {
        value: 28,
        standardError68: 3.5,
        standardError95: 6.9,
      },
      avgSuccessRatePostSignolWeighted: {
        value: 31.6,
        standardError68: 4.8,
        standardError95: 9.3,
      },
      avgSuccessRateChange: {
        value: 3.5,
        standardError68: 6,
        standardError95: 11.7,
      },
    },
    {
      behaviourKey: "OPTIMAL_TRIM",
      behaviourName: "Optimal Trim",
      behaviourAcronym: "OT",
      behaviourPosition: 3,

      countEventsPerformablePreSignol: 92,
      countEventsPerformablePostSignol: 85,
      countEventsPerformedPreSignol: 38,
      countEventsPerformedPostSignol: 37,
      avgSuccessRatePreSignolWeighted: {
        value: 41.3,
        standardError68: 5.1,
        standardError95: 10.1,
      },
      avgSuccessRatePostSignolWeighted: {
        value: 43.5,
        standardError68: 5.4,
        standardError95: 10.5,
      },
      avgSuccessRateChange: {
        value: 2.2,
        standardError68: 7.5,
        standardError95: 14.7,
      },
    },
    {
      behaviourKey: "OPTIMAL_BOILER_LOAD",
      behaviourName: "Optimal Boiler Load",
      behaviourAcronym: "OBL",
      behaviourPosition: 5,
      countEventsPerformablePreSignol: 92,
      countEventsPerformablePostSignol: 154,
      countEventsPerformedPreSignol: 38,
      countEventsPerformedPostSignol: 55,
      avgSuccessRatePreSignolWeighted: {
        value: 41.3,
        standardError68: 5.1,
        standardError95: 10.1,
      },
      avgSuccessRatePostSignolWeighted: {
        value: 40.7,
        standardError68: 3.9,
        standardError95: 7.6,
      },
      avgSuccessRateChange: {
        value: -0.4,
        standardError68: 2.3,
        standardError95: 4.9,
      },
    },
  ],
  [moment.utc().subtract(2, "months").format("YYYY/MM/DD")]: [
    {
      behaviourKey: "EFFICIENT_AUXILIARY_ENGINE_USE",
      behaviourName: "Efficient Auxiliary Engine Use",
      behaviourAcronym: "EAEU",
      behaviourPosition: 2,
      countEventsPerformablePreSignol: 49,
      countEventsPerformablePostSignol: 22,
      countEventsPerformedPreSignol: 22,
      countEventsPerformedPostSignol: 10,
      avgSuccessRatePreSignolWeighted: {
        value: 44.9,
        standardError68: 7.1,
        standardError95: 13.9,
      },
      avgSuccessRatePostSignolWeighted: {
        value: 45.5,
        standardError68: 10.6,
        standardError95: 20.8,
      },
      avgSuccessRateChange: {
        value: 0.6,
        standardError68: 11.9,
        standardError95: 23.2,
      },
    },
    {
      behaviourKey: "PROMPT_DEPARTURE",
      behaviourName: "Prompt Departure",
      behaviourAcronym: "PD",
      behaviourPosition: 4,
      countEventsPerformablePreSignol: 398,
      countEventsPerformablePostSignol: 64,
      countEventsPerformedPreSignol: 156,
      countEventsPerformedPostSignol: 21,
      avgSuccessRatePreSignolWeighted: {
        value: 39.2,
        standardError68: 2.4,
        standardError95: 4.8,
      },
      avgSuccessRatePostSignolWeighted: {
        value: 32.8,
        standardError68: 5.9,
        standardError95: 11.5,
      },
      avgSuccessRateChange: {
        value: 6.4,
        standardError68: 6.3,
        standardError95: 12.4,
      },
    },
    {
      behaviourKey: "EFFICIENT_SFOC",
      behaviourName: "Efficient SFOC",
      behaviourAcronym: "ESFOC",
      behaviourPosition: 1,
      countEventsPerformablePreSignol: 164,
      countEventsPerformablePostSignol: 100,
      countEventsPerformedPreSignol: 46,
      countEventsPerformedPostSignol: 30,
      avgSuccessRatePreSignolWeighted: {
        value: 28,
        standardError68: 3.5,
        standardError95: 6.9,
      },
      avgSuccessRatePostSignolWeighted: {
        value: 30,
        standardError68: 4.6,
        standardError95: 9,
      },
      avgSuccessRateChange: {
        value: 2,
        standardError68: 5.6,
        standardError95: 11,
      },
    },
    {
      behaviourKey: "OPTIMAL_TRIM",
      behaviourName: "Optimal Trim",
      behaviourAcronym: "OT",
      behaviourPosition: 3,

      countEventsPerformablePreSignol: 92,
      countEventsPerformablePostSignol: 56,
      countEventsPerformedPreSignol: 38,
      countEventsPerformedPostSignol: 10,
      avgSuccessRatePreSignolWeighted: {
        value: 41.3,
        standardError68: 5.1,
        standardError95: 10.1,
      },
      avgSuccessRatePostSignolWeighted: {
        value: 17.9,
        standardError68: 5.1,
        standardError95: 10,
      },
      avgSuccessRateChange: {
        value: 23.4,
        standardError68: 7.3,
        standardError95: 14.2,
      },
    },
  ],
  [moment.utc().subtract(3, "months").format("YYYY/MM/DD")]: [
    {
      behaviourKey: "EFFICIENT_AUXILIARY_ENGINE_USE",
      behaviourName: "Efficient Auxiliary Engine Use",
      behaviourAcronym: "EAEU",
      behaviourPosition: 2,
      countEventsPerformablePreSignol: 49,
      countEventsPerformablePostSignol: 37,
      countEventsPerformedPreSignol: 22,
      countEventsPerformedPostSignol: 23,
      avgSuccessRatePreSignolWeighted: {
        value: 44.9,
        standardError68: 7.1,
        standardError95: 13.9,
      },
      avgSuccessRatePostSignolWeighted: {
        value: 62.2,
        standardError68: 8,
        standardError95: 15.6,
      },
      avgSuccessRateChange: {
        value: 17.3,
        standardError68: 10.7,
        standardError95: 20.9,
      },
    },
    {
      behaviourKey: "PROMPT_DEPARTURE",
      behaviourName: "Prompt Departure",
      behaviourAcronym: "PD",
      behaviourPosition: 4,
      countEventsPerformablePreSignol: 398,
      countEventsPerformablePostSignol: 70,
      countEventsPerformedPreSignol: 156,
      countEventsPerformedPostSignol: 17,
      avgSuccessRatePreSignolWeighted: {
        value: 39.2,
        standardError68: 2.4,
        standardError95: 4.8,
      },
      avgSuccessRatePostSignolWeighted: {
        value: 24.3,
        standardError68: 5.1,
        standardError95: 10,
      },
      avgSuccessRateChange: {
        value: 14.9,
        standardError68: 5.7,
        standardError95: 11.1,
      },
    },
    {
      behaviourKey: "EFFICIENT_SFOC",
      behaviourName: "Efficient SFOC",
      behaviourAcronym: "ESFOC",
      behaviourPosition: 1,
      countEventsPerformablePreSignol: 164,
      countEventsPerformablePostSignol: 95,
      countEventsPerformedPreSignol: 46,
      countEventsPerformedPostSignol: 30,
      avgSuccessRatePreSignolWeighted: {
        value: 28,
        standardError68: 3.5,
        standardError95: 6.9,
      },
      avgSuccessRatePostSignolWeighted: {
        value: 31.6,
        standardError68: 4.8,
        standardError95: 9.3,
      },
      avgSuccessRateChange: {
        value: 3.5,
        standardError68: 6,
        standardError95: 11.7,
      },
    },
    {
      behaviourKey: "OPTIMAL_TRIM",
      behaviourName: "Optimal Trim",
      behaviourAcronym: "OT",
      behaviourPosition: 3,

      countEventsPerformablePreSignol: 92,
      countEventsPerformablePostSignol: 85,
      countEventsPerformedPreSignol: 38,
      countEventsPerformedPostSignol: 37,
      avgSuccessRatePreSignolWeighted: {
        value: 41.3,
        standardError68: 5.1,
        standardError95: 10.1,
      },
      avgSuccessRatePostSignolWeighted: {
        value: 43.5,
        standardError68: 5.4,
        standardError95: 10.5,
      },
      avgSuccessRateChange: {
        value: 2.2,
        standardError68: 7.5,
        standardError95: 14.7,
      },
    },
  ],
  [moment.utc().subtract(4, "months").format("YYYY/MM/DD")]: [
    {
      behaviourKey: "EFFICIENT_AUXILIARY_ENGINE_USE",
      behaviourName: "Efficient Auxiliary Engine Use",
      behaviourAcronym: "EAEU",
      behaviourPosition: 2,
      countEventsPerformablePreSignol: 49,
      countEventsPerformablePostSignol: 22,
      countEventsPerformedPreSignol: 22,
      countEventsPerformedPostSignol: 10,
      avgSuccessRatePreSignolWeighted: {
        value: 44.9,
        standardError68: 7.1,
        standardError95: 13.9,
      },
      avgSuccessRatePostSignolWeighted: {
        value: 45.5,
        standardError68: 10.6,
        standardError95: 20.8,
      },
      avgSuccessRateChange: {
        value: 0.6,
        standardError68: 11.9,
        standardError95: 23.2,
      },
    },
    {
      behaviourKey: "PROMPT_DEPARTURE",
      behaviourName: "Prompt Departure",
      behaviourAcronym: "PD",
      behaviourPosition: 4,
      countEventsPerformablePreSignol: 398,
      countEventsPerformablePostSignol: 64,
      countEventsPerformedPreSignol: 156,
      countEventsPerformedPostSignol: 21,
      avgSuccessRatePreSignolWeighted: {
        value: 39.2,
        standardError68: 2.4,
        standardError95: 4.8,
      },
      avgSuccessRatePostSignolWeighted: {
        value: 32.8,
        standardError68: 5.9,
        standardError95: 11.5,
      },
      avgSuccessRateChange: {
        value: 6.4,
        standardError68: 6.3,
        standardError95: 12.4,
      },
    },
    {
      behaviourKey: "EFFICIENT_SFOC",
      behaviourName: "Efficient SFOC",
      behaviourAcronym: "ESFOC",
      behaviourPosition: 1,
      countEventsPerformablePreSignol: 164,
      countEventsPerformablePostSignol: 100,
      countEventsPerformedPreSignol: 46,
      countEventsPerformedPostSignol: 30,
      avgSuccessRatePreSignolWeighted: {
        value: 28,
        standardError68: 3.5,
        standardError95: 6.9,
      },
      avgSuccessRatePostSignolWeighted: {
        value: 30,
        standardError68: 4.6,
        standardError95: 9,
      },
      avgSuccessRateChange: {
        value: 2,
        standardError68: 5.6,
        standardError95: 11,
      },
    },
    {
      behaviourKey: "OPTIMAL_TRIM",
      behaviourName: "Optimal Trim",
      behaviourAcronym: "OT",
      behaviourPosition: 3,

      countEventsPerformablePreSignol: 92,
      countEventsPerformablePostSignol: 56,
      countEventsPerformedPreSignol: 38,
      countEventsPerformedPostSignol: 10,
      avgSuccessRatePreSignolWeighted: {
        value: 41.3,
        standardError68: 5.1,
        standardError95: 10.1,
      },
      avgSuccessRatePostSignolWeighted: {
        value: 17.9,
        standardError68: 5.1,
        standardError95: 10,
      },
      avgSuccessRateChange: {
        value: 23.4,
        standardError68: 7.3,
        standardError95: 14.2,
      },
    },
  ],
  [moment.utc().subtract(5, "months").format("YYYY/MM/DD")]: [
    {
      behaviourKey: "EFFICIENT_AUXILIARY_ENGINE_USE",
      behaviourName: "Efficient Auxiliary Engine Use",
      behaviourAcronym: "EAEU",
      behaviourPosition: 2,
      countEventsPerformablePreSignol: 49,
      countEventsPerformablePostSignol: 37,
      countEventsPerformedPreSignol: 22,
      countEventsPerformedPostSignol: 23,
      avgSuccessRatePreSignolWeighted: {
        value: 44.9,
        standardError68: 7.1,
        standardError95: 13.9,
      },
      avgSuccessRatePostSignolWeighted: {
        value: 62.2,
        standardError68: 8,
        standardError95: 15.6,
      },
      avgSuccessRateChange: {
        value: 17.3,
        standardError68: 10.7,
        standardError95: 20.9,
      },
    },
    {
      behaviourKey: "PROMPT_DEPARTURE",
      behaviourName: "Prompt Departure",
      behaviourAcronym: "PD",
      behaviourPosition: 4,
      countEventsPerformablePreSignol: 398,
      countEventsPerformablePostSignol: 70,
      countEventsPerformedPreSignol: 156,
      countEventsPerformedPostSignol: 17,
      avgSuccessRatePreSignolWeighted: {
        value: 39.2,
        standardError68: 2.4,
        standardError95: 4.8,
      },
      avgSuccessRatePostSignolWeighted: {
        value: 24.3,
        standardError68: 5.1,
        standardError95: 10,
      },
      avgSuccessRateChange: {
        value: 14.9,
        standardError68: 5.7,
        standardError95: 11.1,
      },
    },
    {
      behaviourKey: "EFFICIENT_SFOC",
      behaviourName: "Efficient SFOC",
      behaviourAcronym: "ESFOC",
      behaviourPosition: 1,
      countEventsPerformablePreSignol: 164,
      countEventsPerformablePostSignol: 95,
      countEventsPerformedPreSignol: 46,
      countEventsPerformedPostSignol: 30,
      avgSuccessRatePreSignolWeighted: {
        value: 28,
        standardError68: 3.5,
        standardError95: 6.9,
      },
      avgSuccessRatePostSignolWeighted: {
        value: 31.6,
        standardError68: 4.8,
        standardError95: 9.3,
      },
      avgSuccessRateChange: {
        value: 3.5,
        standardError68: 6,
        standardError95: 11.7,
      },
    },
    {
      behaviourKey: "OPTIMAL_TRIM",
      behaviourName: "Optimal Trim",
      behaviourAcronym: "OT",
      behaviourPosition: 3,

      countEventsPerformablePreSignol: 92,
      countEventsPerformablePostSignol: 85,
      countEventsPerformedPreSignol: 38,
      countEventsPerformedPostSignol: 37,
      avgSuccessRatePreSignolWeighted: {
        value: 41.3,
        standardError68: 5.1,
        standardError95: 10.1,
      },
      avgSuccessRatePostSignolWeighted: {
        value: 43.5,
        standardError68: 5.4,
        standardError95: 10.5,
      },
      avgSuccessRateChange: {
        value: 2.2,
        standardError68: 7.5,
        standardError95: 14.7,
      },
    },
  ],
};

export const getSuccessRateVsPreSignolRespMaritime = (
  teamId,
  startDate,
  endDate,
) => {
  let data = shippingAllTimeValues;
  if (startDate || endDate) {
    let monthsAgo =
      differenceInMonths(new Date(), new Date(endDate || startDate)) + 1;
    monthsAgo = monthsAgo > 5 ? 5 : monthsAgo; // just return the fifth month for any months further back in time
    data =
      shippingMonthyValues[
        moment.utc().subtract(monthsAgo, "months").format("YYYY/MM/DD")
      ];
  }
  return data;
};
